export const HOSTNAME = process.env.REACT_APP_HOSTNAME;


// 로컬/개발계에서만 노출 (운영 API는 api.buccl.com, 로컬·개발계는 apidev.buccl.com)
export const isDevEnv =
        process.env.REACT_APP_API_URL?.includes("apidev") ||
        ["localhost", "127.0.0.1"].includes(window.location.hostname);